import { authState } from './auth.svelte';

// Svelte 5 reactive router using runes
let currentRoute = $state('login');

// Initialize router - check hash on load
if (typeof window !== 'undefined') {
  const hash = window.location.hash.slice(1) || 'login';
  currentRoute = hash.split('?')[0];

  // Listen for hash changes
  window.addEventListener('hashchange', () => {
    const newHash = window.location.hash.slice(1) || 'login';
    currentRoute = newHash.split('?')[0];
  });
}

export const router = {
  get route() {
    return currentRoute;
  },
  
  navigate(path: string) {
    window.location.hash = path;
  },
  
  // Auto-redirect logic based on auth state
  get shouldRedirect() {
    // If user is authenticated and on login/join pages, redirect to dashboard
    // Exception: signup/signup-flow is allowed for authenticated users (payment step)
    // Exception: reset-password/set-password/forgot-password are allowed for all users
    //   (logged in users may want to change password, or may have a stale session)
    if (authState.isAuthenticated && ['login', 'join'].includes(currentRoute)) {
      return 'dashboard';
    }

    // If user is not authenticated and on protected pages, redirect to login
    // signup/signup-flow/set-password is allowed for unauthenticated users (registration/password reset)
    if (!authState.isAuthenticated && currentRoute === 'dashboard') {
      return 'login';
    }

    return null;
  }
};

// Helper to get query params
export function getQueryParams(): Record<string, string> {
  const params: Record<string, string> = {};
  const hash = window.location.hash;
  const queryString = hash.includes('?') ? hash.split('?')[1] : '';
  
  if (queryString) {
    queryString.split('&').forEach(param => {
      const [key, value] = param.split('=');
      if (key) {
        params[key] = decodeURIComponent(value || '');
      }
    });
  }
  
  return params;
}